import { REWARD_CATEGORY_ICONS } from './rewardCategoryIconPaths'

export interface RewardCategoryIconProps {
  /**
   * Category slug from the bundled catalogue (`selfcare`, `pets`, …), or
   * `checkAll` for the "Alle Kategorien" entry.
   */
  slug: string
  /** Rendered edge length in px. Figma: 16 in the filter menu. */
  size?: number
  className?: string
}

/**
 * Line icon for a reward category (Figma 3332:48995).
 *
 * Renders nothing for an unknown slug — a category added in Supabase without a
 * matching icon degrades to a label-only row instead of breaking the menu.
 *
 * @example
 * <RewardCategoryIcon slug={category.slug} />
 */
export const RewardCategoryIcon = ({ slug, size = 16, className }: RewardCategoryIconProps) => {
  const icon = REWARD_CATEGORY_ICONS[slug]
  if (!icon) return null

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox={icon.viewBox}
      fill="none"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      {icon.content}
    </svg>
  )
}
